import { useEffect, useState } from 'react';

/**
 * Hook to detect if the user is on a mobile device
 * Checks both screen size and user agent
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      // Check screen width (mobile if less than 768px)
      const isSmallScreen = window.innerWidth < 768;

      // Check user agent for mobile devices
      const isMobileDevice =
        /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
          navigator.userAgent,
        );

      setIsMobile(isSmallScreen || isMobileDevice);
    };

    // Check on mount
    checkIfMobile();

    // Add resize listener
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return isMobile;
};
